/**
 * External Imports
 */
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuImage, NeuTable } from '@neutron/react';

interface ICellContainerStyleProps {
  colWidth: number;
  alignment?: string;
  styles?: string;
}

interface IStyledNeuTableRowStyleProps {
  height?: number | string;
  styles?: string;
}

interface ITableBodyStyleProps {
  offset?: string;
}

export const CellContainer = styled(NeuTable)<ICellContainerStyleProps>`
  height: 100%;
  padding: 0;
  td {
    flex: 0 0 ${props => `${props.colWidth}%`};
    justify-content: ${props => `${props.alignment ?? 'center'}`};
    overflow: hidden;
    ${props => props.styles}
  }
`;

export const StyledNeuTableRow = styled(NeuTable)<IStyledNeuTableRowStyleProps>`
  align-items: center !important;
  tr {
    border: none !important;
    height: ${({ height = '4.5em' }) => height};
    ${({ styles }) => styles}
  }
`;

export const CellDiv = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
`;

export const StyledLabel = styled.div`
  font-size: 14px;
  line-height: 22px;
  margin-right: 2px;
  overflow: hidden;
  white-space: normal;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
`;

// TODO: possibly can get rid of with app bold class
export const StyledBoldLabel = styled(StyledLabel)`
  font-weight: bold;
`;

export const StyledNoWrapLabel = styled(StyledLabel)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CategoryContainer = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: auto auto;
  align-items: start;
  font-size: 14px;
  line-height: 22px;
  white-space: normal;
`;
export const CategoryLabel = styled.div`
  font-weight: bold;
  font-size: 14px;
  line-height: 22px;
  max-width: 150px;
  position: absolute;
  margin-left: -25px;
`;

export const CategoryIndent = styled.div`
  margin-left: 25px;
`;

export const CategoryText = styled.div`
  font-weight: bold;
`;

export const ServiceCentralContainer = styled.div`
  min-width: 50px;
  min-height: 50px;
  max-width: 50px;
  max-height: 50px;
  padding: 5px;
`;
export const ServiceCentralLogo = styled(NeuImage)`
  min-width: 25px;
  min-height: 25px;
  max-width: 25px;
  max-height: 25px;
  margin-right: 0px;
`;

export const TableHeader = styled(NeuTable)``;

export const TableContent = styled(NeuTable)<ITableBodyStyleProps>`
  tbody {
    scroll-behavior: smooth;
    height: calc(100% - ${({ offset }) => offset ?? '126px'});
    overflow: auto;
    position: relative;
  }
`;

export const TableContentContainer = styled.div`
  display: content;
`;

export const TableFooter = styled.div`
  display: flex;
  justify-content: end;
  height: 56px;
  align-items: center;
  margin: 0.5em 0;
  width: 100%;
`;

export const TextContainer = styled.div`
  grid-column: 2;
  display: flex;
  flex-direction: column;
`;
